import { createPinia } from 'pinia'
import { createPersistedState } from 'pinia-plugin-persistedstate'

const pinia = createPinia()

// 默认使用 localStorage 持久化，store 中通过 persist 选项开启
pinia.use(
  createPersistedState({
    storage: localStorage,
    key: (id) => `om_pay_store_${id}`,
  }),
)

export default pinia
